import { imageProvider } from './config/imageProvider/imageProviderConfig';
import { redirect } from './redirect';
import { criticalFonts } from "./assets/scss/components/critical-fonts";

const version = new Date().getTime();
export const BASE_URL = process.env.BASE_API_URL;
export const BASE_API_URL = `${BASE_URL}/api/`;
export const YANDEX_METRIKS_NUMBER = 61311100;
// eslint-disable-next-line max-len,vue/max-len
export const CONF_TOKEN = 'a26ac89e14e68c5f8f1e1246622b88ec83774411009035bbd95e614acebf9f553EuOp-e0m40lWWyqx8T7ZW6ToSLUFnVf';

export default {
  modern: process.env.ENVIRONMENT === 'production',
  server: {
    port: process.env.APP_PORT,
    host: process.env.APP_IP,
  },
  // Global page headers: https://go.nuxtjs.dev/config-head
  head: {
    title: 'pdn66',
    htmlAttrs: {
      lang: 'ru',
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { hid: 'metadescription', name: 'description', content: '' },
    ],
    link: [
      { rel: 'icon', type: 'image/svg+xml', href: '/favicon.ico' },

      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Black.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Bold.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-ExtraBold.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Light.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-ExtraLight.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Medium.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Regular.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-SemiBold.woff2', crossorigin: true},
      {rel: 'preload', as: 'font', type: 'font/woff2', href: '/fonts/Onest-Thin.woff2', crossorigin: true},
    ],
    style: [
      {type: 'text/css', cssText: criticalFonts()},
    ],
    script: [
      {
        type: 'text/javascript', body: true, src: '/js/sourcebuster.min.js', async: true,
      },
    ],
  },

  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    '~/assets/scss/main.scss',
  ],

  serverMiddleware: [
    { path: '/robots.txt', handler: '~/server-middleware/robots' },
    '~/server-middleware/sitemap',
    '~/server-middleware/redirectWww'
  ],

  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    { src: '~/plugins/Vuelidate.js' },
    { src: '~plugins/vue-range-slider.js', ssr: false },
    // '~plugins/vue-js-modal.js',
    '~plugins/vue-mask.js',
    // '~/plugins/gtag.js',
    '~plugins/phone-format.js',
    '~plugins/number-format.js',
    '~plugins/get-cookies-opt.js',
    '~plugins/vue-multiselect.js',
    '~plugins/pop-up-notification.js',
  ],

  // Build Configuration: https://go.nuxtjs.dev/config-build

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [
    // https://go.nuxtjs.dev/typescript
    '@nuxt/typescript-build'
  ],
  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    'cookie-universal-nuxt',
    '@nuxt/image',
    '@nuxtjs/style-resources',
    '@nuxtjs/toast',
    '~/modules/change-img.js',
    ['@nuxtjs/redirect-module', { statusCode: 301 }],
    // Yandex Metrika
    // [
    //   '@rkaliev/nuxtjs-yandex-metrika',
    //   {
    //     id: 74180731,
    //     clickmap: true,
    //     trackLinks: true,
    //     accurateTrackBounce: true,
    //     webvisor: true,
    //     disabled: Boolean(process.env.ENVIRONMENT !== 'production'),
    //   },
    // ],
    ['~/node_modules/sitis-nuxt/lib', {
      baseUrl: BASE_API_URL,
      // cmsRoot: 'cms' - default
    }],
  ],
  image: imageProvider(BASE_API_URL),
  // '@nuxtjs/toast' config
  toast: {
    position: 'top-right',
    duration: 3000,
  },
  components: false,

  router: {
    trailingSlash: false,
    extendRoutes(routes, resolve) {
      // Страница специалиста
      routes.unshift({
        path: '/articles',
        components: {
          default: resolve(__dirname, 'pages/news/index.vue'),
        },
        chunkNames: {
          default: 'article-main',
        },
      });

      routes.unshift({
        path: '/articles/:slug',
        components: {
          default: resolve(__dirname, 'pages/news/_slug.vue'),
        },
        chunkNames: {
          default: 'article-item',
        },
      });
    },
  },

  render: {
    bundleRenderer: {
      shouldPreload: (file, type) => ['font', 'script', 'style'].includes(type),
    },
  },
  build: {
    extend(config, { isClient }) {
      // Extend only webpack config for client-bundle

      if (isClient) {
        config.devtool = 'source-map';
      }
    },
    filenames: {
      img: ({ isDev }) => (isDev ? `[path][name].[ext]?v=${version}` : `img/[name].[ext]?v=${version}`),
      app: ({
        isDev,
        isModern,
      }) => (isDev ? `[name]${isModern ? '.modern' : ''}.js?v=${version}` : `[name]${isModern ? '.modern' : ''}.js?v=${version}`),
      chunk: ({
        isDev,
        isModern,
      }) => (isDev ? `[name]${isModern ? '.modern' : ''}.js?v=${version}`
        : `[name]${isModern
          ? '.modern' : ''}.js?v=${version}`),
      font: ({ isDev }) => (isDev ? '[path][name].[ext]' : 'fonts/[name].[ext]'),
      css: ({ isDev }) => (isDev ? `[name].css?v=${version}` : `css/[name].css?v=${version}`),
    },
    extractCSS: true,
    optimization: {
      runtimeChunk: 'single',
      splitChunks: {
        chunks: 'all',

        maxInitialRequests: Infinity,
        minSize: 0,
        cacheGroups: {
          vendor: {
            test: /[\\/]node_modules[\\/]/,
            name(module) {
              const packageName = module.context.match(/[\\/]node_modules[\\/](.*?)([\\/]|$)/)[1];
              return `npm.${packageName.replace('@', '')}`;
            },
          },
        },
      },
    },
  },
  redirect,
  env: {
    baseApiUrl: BASE_API_URL,
    baseCookieDomain: process.env.BASE_COOKIE_DOMAIN,
    yandexMetriks: YANDEX_METRIKS_NUMBER,
  },
};
